import { render, staticRenderFns } from "./InicioPainel.vue?vue&type=template&id=9ded578c&"
import script from "./InicioPainel.vue?vue&type=script&lang=js&"
export * from "./InicioPainel.vue?vue&type=script&lang=js&"
import style0 from "./InicioPainel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports